export type VariantOption = {
	uuid: string;
	label: string;
	sageId: string;
	cost: number; // in cents
};

export enum VariantConditionInnerOperator {
	EQUAL = "==",
	NOT_EQUAL = "!=",
}

export type VariantConditionInner = {
	variantId: number | null;
	operator: VariantConditionInnerOperator;
	values: string[];
};

export type VariantCondition = {
	targets: string[];
	conditions: VariantConditionInner[];
};

export type Variant = {
	id: number;
	uuid: string;
	label: string;
	description: string;
	options: {
		data: VariantOption[];
		conditions: VariantCondition[];
	};
};

export enum EarmoldStatus {
	DRAFT = "DRAFT",
	ACTIVE = "ACTIVE",
}

export type Earmold = {
	id: number;
	uuid: string;
	label: string;
	status: EarmoldStatus;
	variants: Variant[];
	price: number;
	sageId: string;
};
